module.exports = __webpack_public_path__ + "static/media/polygon_gold.d357fead.svg";